module.exports = __webpack_public_path__ + "img/home-background-v2.dbe83a18.png";